import { io } from 'socket.io-client';

class SocketService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
    this.listeners = new Map();
  }
  
  // Connect to the WebSocket server
  connect() {
    if (this.socket) return;
    
    // Use the environment variable or fall back to origin
    const socketUrl = process.env.REACT_APP_SOCKET_URL || window.location.origin;
    
    this.socket = io(socketUrl, {
      path: '/socket.io',
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000
    });
    
    // Set up event listeners
    this.socket.on('connect', () => {
      console.log('Socket connected:', this.socket.id);
      this.isConnected = true;
    });
    
    this.socket.on('disconnect', (reason) => {
      console.log('Socket disconnected:', reason);
      this.isConnected = false;
    });
    
    this.socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
    });
  }
  
  // Disconnect from WebSocket server
  disconnect() {
    if (!this.socket) return;
    
    this.socket.disconnect();
    this.socket = null;
    this.isConnected = false;
    this.listeners.clear();
  }
  
  // Check if socket is connected
  isSocketConnected() {
    return this.isConnected && this.socket && this.socket.connected;
  }
  
  // Subscribe to an event
  on(event, callback) {
    if (!this.socket) {
      console.error('Socket not initialized. Call connect() first.');
      return;
    }
    
    // Add to local listeners map
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event).add(callback);
    
    // Add socket event listener
    this.socket.on(event, callback);
  }
  
  // Unsubscribe from an event
  off(event, callback) {
    if (!this.socket) return;
    
    // Remove from local listeners map
    if (this.listeners.has(event)) {
      this.listeners.get(event).delete(callback);
    }
    
    // Remove socket event listener
    this.socket.off(event, callback);
  }
  
  // Emit an event
  emit(event, data) {
    if (!this.socket) {
      console.error('Socket not initialized. Call connect() first.');
      return;
    }
    
    this.socket.emit(event, data);
  }
}

// Create singleton instance
const socketService = new SocketService();

export default socketService;